import { SignupScreen, UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Product from 'react-native-iaphub/src/models/product'; // todo: need to not import from their internal models
import { connect } from 'react-redux';
import WelcomeBackground from '../assets/images/welcome1-background.png';
import { IAppStore } from '../HomeWorkouts';
import PreLoadedPlanDetails from '../payments/PreLoadedPlanDetails';
import { UserProfileService } from '../services';
import { InAppPurchaseService } from '../services/iap';
import { UserDataConsumer } from '../utils';
import { buyIapProduct, getNextStep, navigateToNextStep } from './actions';
import { InAppPurchase } from './InAppPurchase';
import { INavigateToNextStep } from './types';

interface IProps {
  isLoading: boolean;
  error?: string;
  product: Product | null;
  userProfile: UserProfile;
  navigation: any;
  user: {
    userProfileService: UserProfileService;
    userProfile: UserProfile,
  };
  t(key: string): string;
  buyIapProduct(onSuccess: () => void): void;
  getNextStep(navigateToNextStep: INavigateToNextStep): void;
  navigateToNextStep(navigateToNextStep: any): void;
}

interface IState {
  isLoading: boolean;
  error: string | null;
}

class SubscribeToInAppPurchaseScreen extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public onJoinSuccess = async () => {
    await this.props.user.userProfileService.refreshCurrentUserProfile();
    this.getNextScreenAndNavigate();
  }

  public getNextScreenAndNavigate = () => {
    const { userProfile } = this.props;
    this.props.getNextStep({
      userProfile,
      currentScreen: SignupScreen.IAPSubscription,
    });
    this.props.navigateToNextStep(this.props.navigation);
  }

  public render() {
    const { user: { userProfile } } = this.props;
    return (
      <>
        {UserProfile.signedUpThroughInfluencerLink(userProfile) ?
          <PreLoadedPlanDetails onJoinSuccess={this.onJoinSuccess} navigation={this.props.navigation} />
          :
            <InAppPurchase
              forcePaymentOrLogout
              navigation={this.props.navigation}
              onJoinSuccess={this.onJoinSuccess}
              backgroundImage={WelcomeBackground}
            />
        }
      </>
    );
  }
}

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    error: state.auth.signup.iap.error,
    isLoading: state.auth.signup.iap.isLoading,
    product: state.auth.signup.iap.product,
    userProfile: state.auth.signup.userProfile,
  };
};

const mapDispatchToProps = (dispatch): Partial<IProps> => ({
  buyIapProduct: (onSuccess) => dispatch(buyIapProduct(InAppPurchaseService, onSuccess)),
  getNextStep: (navigationOptions: INavigateToNextStep) => dispatch(getNextStep(navigationOptions)),
  navigateToNextStep: (navigation) => dispatch(navigateToNextStep(navigation)),
});

const SubscribeToInAppPurchaseRedux = connect(mapStateToProps, mapDispatchToProps)(SubscribeToInAppPurchaseScreen);
export const SubscribeToInAppPurchase = translate(['auth', 'formFields'], { wait: true })(
  UserDataConsumer(SubscribeToInAppPurchaseRedux),
);
